import { addListenerToSelector } from "@rootreeweb/js-lib";

import FoundationFormTracker from "./foundation-form-tracking.js";
import type { PlausibleProps } from "./plausible.js";
import createDispatch from "./tracking-dispatch.js";

const APPLY_SELECTOR = '[data-rt-track="foundation-apply"]';
const DISCOVER_PRIZES_SELECTOR = 'a[href*="#foundation-prizes"]';
const FORM_SELECTOR = ".rt-foundation-form";
const PRIZE_QUERY_ARG = "prize";

/** The facts resolved server-side that every tracked event is cut by. */
export type TrackingContext = {
	activeFormIds: string[];
	locale: string;
	region: string;
};

/**
 * Initializes conversion tracking for the RT Foundation pages.
 *
 * @param context The server-resolved locale and region, and the active form
 *   IDs.
 */
export default function (context: TrackingContext): void {
	const form = document.querySelector(FORM_SELECTOR);
	const prize =
		new URLSearchParams(window.location.search).get(PRIZE_QUERY_ARG) ?? "none";
	const baseProps: PlausibleProps = {
		locale: context.locale,
		page: form ? "apply" : "landing",
		prize,
		region: context.region,
	};
	const dispatch = createDispatch(baseProps);

	addListenerToSelector(DISCOVER_PRIZES_SELECTOR, "click", () => {
		dispatch("discoverPrizes", { placement: "discover" });
	});

	addListenerToSelector<HTMLElement>(
		APPLY_SELECTOR,
		"click",
		(_event, element) => {
			dispatch("prizeClick", {
				placement: element.dataset.rtPlacement ?? "unknown",
				prize: element.dataset.rtPrize ?? prize,
			});
		},
	);

	if (form) {
		const tracker = new FoundationFormTracker(
			form,
			{
				activeFormIds: context.activeFormIds,
				prefilled: prize !== "none",
			},
			dispatch,
		);

		tracker.watch();
	}
}
